import { useEffect, useState } from 'react';
import { constants } from '../../constants';
import { FieldArrayRenderProps, FieldHookConfig, useField } from 'formik';
import CustomField from './CustomField';
import { useTranslation } from 'react-i18next';

const getHookEndpoint = (moduleId: string | undefined) => {
  if (!moduleId) {
    return '';
  }

  return `${constants.endpoint}/webhooks/answer?fields=user,userParams&leadingModuleId=${moduleId}&question={text}&ans={ans}`;
};

function ModuleIdField(
  props: FieldHookConfig<string> & { onDelete: () => void }
) {
  const [t] = useTranslation(['admin']);
  const [field] = useField(props);
  const [hookEndpoint, setHookEndpoint] = useState(
    getHookEndpoint(field.value)
  );

  useEffect(() => {
    setHookEndpoint(getHookEndpoint(field.value));
  }, [field]);

  return (
    <div className="grid grid-cols-2 gap-4 mb-4">
      <CustomField
        title={t('activity_daily_module_id', '每日對話模組 ID')}
        placeholder={t(
          'activity_daily_module_id_placeholder',
          '請填入每日活動啟動的對話模組 ID'
        )}
        name={props.name}
      />

      <div className="flex items-end gap-4">
        <input
          className="h-10 flex-grow border border-[#53586C] rounded py-3 px-4 placeholder:text-gray-700/70 mt-3"
          value={hookEndpoint}
          disabled={true}
        />
        <button
          className="flex flex-shrink items-center text-group-primary font-medium mb-2"
          type="button"
          onClick={props.onDelete}
        >
          <span className="material-symbols-outlined">delete</span>
        </button>
      </div>
    </div>
  );
}

export function ModuleIdFieldContainer(
  props: void | undefined | FieldArrayRenderProps
) {
  const [t] = useTranslation(['admin']);
  if (!props) {
    return <></>;
  }

  const moduleIds: string[] = props.form.values.moduleIds;

  return (
    <>
      {moduleIds.map((v, i) => {
        return (
          <ModuleIdField
            key={i}
            name={`moduleIds.${i}`}
            onDelete={() => props.remove(i)}
          ></ModuleIdField>
        );
      })}

      <button
        type="button"
        className="text-group-primary border border-group-primary py-3 px-8 rounded text-center disabled:opacity-30 disabled:cursor-not-allowed w-fit mb-4"
        onClick={() => props.push('')}
      >
        {t('add_activity_daily_module', '新增每日對話模組')}
      </button>
    </>
  );
}
